import React, { useCallback, useEffect, useState } from 'react';
const NAMES = ['María', 'Lucas', 'Carolina', 'Andrea', 'Roberto', 'Valentina', 'Martín', 'Sofía', 'Diego', 'Camila'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Chaco', 'San Juan'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    province: ''
  });
  const showPopup = useCallback(() => {
    setCurrentPurchase({
      name: NAMES[Math.floor(Math.random() * NAMES.length)],
      province: PROVINCES[Math.floor(Math.random() * PROVINCES.length)]
    });
    setIsVisible(true);
  }, []);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let showTimer: ReturnType<typeof setTimeout>;
    const scheduleNext = () => {
      const delay = Math.floor(Math.random() * 4000) + 8000;
      showTimer = setTimeout(() => {
        showPopup();
        hideTimer = setTimeout(() => {
          setIsVisible(false);
          scheduleNext();
        }, 4000);
      }, delay);
    };
    showTimer = setTimeout(() => {
      showPopup();
      hideTimer = setTimeout(() => {
        setIsVisible(false);
        scheduleNext();
      }, 4000);
    }, 3000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, [showPopup]);
  return <div className={`fixed bottom-3 left-3 z-50 rounded-lg px-3 py-2.5 flex items-center gap-2.5 transition-all duration-300 ${isVisible ? 'opacity-100 translate-x-0 translate-y-0' : 'opacity-0 -translate-x-16 translate-y-3 pointer-events-none'}`} style={{
    maxWidth: '270px',
    background: 'linear-gradient(135deg, #1a1400 0%, #2a1f00 50%, #1a1400 100%)',
    border: '1.5px solid #d4a017',
    boxShadow: '0 0 12px rgba(212, 160, 23, 0.25), 0 4px 12px rgba(0,0,0,0.3)'
  }} data-id="element-199">
      <span className="text-yellow-400 text-sm flex-shrink-0" data-id="element-200">🏆</span>
      <p className="text-[11px] leading-tight text-yellow-100/80" data-id="element-201">
        <span className="font-bold text-yellow-300" data-id="element-202">
          {currentPurchase.name}
        </span>{' '}
        de {currentPurchase.province} compró el{' '}
        <span className="font-black text-yellow-400" data-id="element-203">Pack Completo ⭐</span>
      </p>
    </div>;
}